export default {
  history: {
    menuItem: "Historial",
    pageTitle: "Actividad del sistema",
    pickDay: "Día",
    filterDateFrom: "Desde",
    filterDateTo: "Hasta",
    filterDateRange: "Rango",
    filterModel: "Modelo",
    filterModelPlaceholder: "Todos los modelos",
    filterUser: "Usuario",
    filterUserAll: "Todos los usuarios",
    filterAction: "Acción",
    filterActionAll: "Todas",
    filterItem: "Ítem",
    filterItemPlaceholder: "Buscar por nombre…",
    filterItemClear: "Quitar ítem",
    filterItemNeedModel: "Elegí un modelo para buscar el ítem.",
    groupContext: "Cambios en grupos del ítem",
    datesRequireItem:
      "Sin ítem hace falta al menos la fecha Desde. Fechas vacías solo con un ítem filtrado.",
    dateRangeTooLarge: "Sin ítem, el rango no puede superar 31 días.",
    clearDatesHint: "Vaciar fechas = historial completo del ítem",
    clearDates: "Vaciar fechas",
    unboundedBadge: "Sin límite de fechas (ítem)",
    refresh: "Actualizar",
    loading: "Cargando…",
    empty: "Sin actividad en este día.",
    emptyFiltered: "Sin actividad para este filtro de acción. Probá con «Todas».",
    timeline: "Timeline",
    timelineTitle: "Línea de tiempo del ítem",
    timelineClose: "Cerrar",
    timelineEmpty: "Sin historial para este ítem.",
    timelineError: "No se pudo cargar la línea de tiempo.",
    timelinePoints: "eventos",
    timelinePointDetail: "Qué cambió",
    timelineDeleted: "Borrado",
    timelineSoftDeleteHint: "Pasado a papelera.",
    tabList: "Lista",
    tabNetwork: "Red",
    graphHint: "Panal de nodos. Arrastrá para reposicionar. Clic = vínculos. Rueda = zoom.",
    graphReset: "Reiniciar",
    graphExpanding: "Cargando vínculos…",
    graphExpandError: "No se pudieron cargar los vínculos.",
    summaryHistory: "Guardados",
    summarySoftDelete: "A papelera",
    summaryHardDelete: "Borrado definitivo",
    summaryPrevDay: "Guardados día anterior",
    summaryDelta: "vs día anterior",
    summaryMissing: "Guardados de ítems ausentes",
    sectionSaves: "Altas y ediciones",
    sectionTrash: "Pasados a papelera (soft delete)",
    sectionHardDelete: "Borrados definitivos",
    hardDeleteOrphanHint: "Tiene historial y el ítem ya no existe",
    hardDeleteEventHint: "Borrado permanente registrado",
    viewItemHistory: "Ver historial",
    actionCreate: "Creado",
    actionUpdate: "Editado",
    actionSoftDelete: "Pasado a papelera",
    actionHardDelete: "Borrado definitivo",
    statusActive: "Activo",
    statusTrash: "En papelera",
    statusMissing: "Ítem ausente (borrado definitivo)",
    statusUnknown: "Desconocido",
    by: "por",
    openItem: "Abrir",
    details: "Detalle",
    before: "Antes",
    after: "Después",
    noDiffs: "Sin diferencias de campos respecto a la versión anterior.",
    notesTitle: "Notas",
    loadError: "No se pudo cargar la actividad.",
    entryError: "No se pudo cargar el detalle.",
  },
};
